import { BetDetailType } from '@bpos/common/bet-placement';
import { Bet } from '@bpos/v2/bet-placement';
import { BposOddsConverterService } from '@frontend/sports/odds/feature';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';

import { IBetslipMessages } from '../../../../../base/models/betslip-messages';
import { BetslipV2GolfWinParticipantPick } from '../../../../../core/picks/sport-specific/betslip-v2-golf-picks';
import { ISlipPick } from '../../../../bet-generation/models';
import { V2ParticiantPickRequestMapper } from './v2-participant-pick-request-mapper';

export class V2GolfWinParticipantPickRequestMapper extends V2ParticiantPickRequestMapper {
    constructor(
        bposOddsConverterService: BposOddsConverterService,
        userOddsFormatSettingsService: UserOddsFormatSettingsService,
        messages: IBetslipMessages,
    ) {
        super(bposOddsConverterService, userOddsFormatSettingsService, messages);
    }

    override mapBetDetails(slipPick: ISlipPick<BetslipV2GolfWinParticipantPick>, bet: Bet): void {
        super.mapBetDetails(slipPick, bet);
        const pick = slipPick.pick;
        const fixture = bet.betDetails.find((x) => x.betDetailType === BetDetailType.Fixture);
        //for GolfWinParticipantPick fixture name comes from fixtureGroup and market names come from fixture that's why we update the name here
        if (fixture) {
            fixture.textValue = {
                value: pick.fixture.fixtureGroup.name.name,
                sign: pick.fixture.fixtureGroup.name.signature,
            };
        }
    }
}
